export function RequiredMessage() {
  return (
    <small className="text-slate-600">
      Campos com <span className="text-red-600 ">*</span> são obrigatórios
    </small>
  );
}
